const zoomLatLng = {
  namespaced: true,
  state: {
    lat: '',
    lng: '',
    current: false
  },
  getters: {
    getLat: (state) => state.lat,
    getLng: (state) => state.lng,
    getCurrent: (state) => state.current
  },
  mutations: {
    setLat (state, lat) {
      state.lat = lat
    },
    setLng (state, lng) {
      state.lng = lng
    },
    setCurrent (state, current) {
      state.current = current
    }
  },
  actions: {
    setLat ({ commit }, lat) {
      commit('setLat', lat)
    },
    setLng ({ commit }, lng) {
      commit('setLng', lng)
    },
    setCurrent ({ commit }, current) {
      commit('setCurrent', current)
    }
  }
}

export default zoomLatLng



// WEBPACK FOOTER //
// ./src/vuex/zoomLatLng.js